module.exports = __webpack_public_path__ + "static/img/EH.7042a2e4.svg";